




















































import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import MerchantItem from '@/components/we-coupons/merchant-item.vue';
import { MerchantInfo } from '@tencent/wphk-components-wecoupon';
import { getSPListByClassId } from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/api';
import PageNav from '@/components/we-coupons/page-nav/index.vue';
import ContentLoadFail from '@/components/we-coupons/content-load-fail/index.vue';
import NoMoreTips from '@/components/we-coupons/no-more-tips/index.vue';
import { getNextCouponClass } from '@/business/we-coupons/coupon-class';
import { biBrow } from '@tencent/fit-bi-sdk';
import { dataLoadCompleteHelper } from './utils/view-helper';
import { MerchantInfoWithAd } from '@/types/we-coupons';
import { getMyFavoritesSpList } from '@/components/my-favorites/api';
import { favoritesStore } from '@/business/favorites-store';
import { MerchantSubscribe } from '@tencent/wphk-components-merchant-favorites';
import { NS } from '@/components/my-favorites/types';


@Component({
  components: {
    MerchantItem,
    PageNav,
    ContentLoadFail,
    NoMoreTips,
    MerchantSubscribe,
  },
})
export default class MerchantList extends Vue {
  @Ref('pageNav') pageNav!: PageNav<MerchantInfo>;
  favoritesStore = favoritesStore;
  subTplInfo = [{
    id: 'subc.wecoupon_online_notify',
    tplId: 'Vp0eojT1lEUceQjBZPwMy0LlGMCSaC4_hEDmCdDr9Vs',
  }];
  NS = NS;
  /**
   * 当前分类ID
   */
  get classId(): string {
    return this.$route.params.classId || '';
  }

  /**
   * 是否有下一分类
   */
  get hasNextClass() {
    return getNextCouponClass(this.classId) !== null;
  }

  /**
   * bi abt 扩展字段
   */
  get biExt() {
    return {
      fclassid: this.classId,
    };
  }

  @Watch('favoritesStore.hasChange')
  favoritesChange() {
    if (this.classId === NS.Favorites) {
      this.pageNav.dataList.forEach((item, index) => {
        if (item.spId === favoritesStore.spId) {
          this.pageNav.dataList.splice(index, 1);
        }
      });
    }
  }
  /**
   * 当前分页加载完毕后通知父亲页面
   */
  handlePageComplete() {
    dataLoadCompleteHelper.notify(this);
  }

  /**
   * 获取分页数据
   * @param offset 数据偏移量
   * @param limit 数据个数
   */
  async queryMerchantList(offset: number, limit: number) {
    biBrow('query.coupons', { fclassid: this.classId });
    if (this.classId === NS.Favorites) {
      return await getMyFavoritesSpList(offset, limit);
    }
    return await getSPListByClassId(this.classId, offset, limit);
  }

  /**
   * 展示商户下券列表
   */
  onCounpon(item: MerchantInfoWithAd) {
    this.$emit('showMerchantDialog', item);
  }
}
